import { DocumentResponse } from '@/types/service-response'

export class Document {
  public constructor (
    readonly id: number,
    readonly autorId: number,
    readonly autorKurzzeichen: string | null,
    readonly autorName: string | null,
    readonly autorVollerName: string | null,
    readonly autorVorname: string | null,
    readonly dokumentGruppeId: number,
    readonly dokumentenBezeichnung: string | null,
    readonly dokumentenCode: string | null,
    readonly dokumentenDatei: string | null,
    readonly erstelltAm: string | null,
    readonly gruppenBezeichnung: string | null,
    readonly gruppenCode: string | null,
    readonly kommentar: string | null
  ) {}

  static createFromResponse (item: DocumentResponse): Document {
    return new Document(
      item.ID,
      item.AutorID,
      item.AutorKurzzeichen,
      item.AutorName,
      item.AutorVollerName,
      item.AutorVorname,
      item.DokumentGruppeID,
      item.DokumentenBezeichnung,
      item.DokumentenCode,
      item.DokumentenDatei,
      item.ErstelltAm,
      item.GruppenBezeichnung,
      item.GruppenCode,
      item.Kommentar
    )
  }

  static createListFromResponse (responseData: DocumentResponse[]): Array<Document> {
    return responseData.map((item: DocumentResponse ) => {
      return new Document(
        item.ID,
        item.AutorID,
        item.AutorKurzzeichen,
        item.AutorName,
        item.AutorVollerName,
        item.AutorVorname,
        item.DokumentGruppeID,
        item.DokumentenBezeichnung,
        item.DokumentenCode,
        item.DokumentenDatei,
        item.ErstelltAm,
        item.GruppenBezeichnung,
        item.GruppenCode,
        item.Kommentar
      )
    })
  }
}
